import { array, any, bool, func, string } from 'prop-types'
import RadioOption from './RadioOption'

const RadioArray = ({ disabled, onChange, options, name, value }) => (
  <fieldset className="radio-array" disabled={disabled}>
    {options.map((option, idx) => (
      <RadioOption
        disabled={disabled}
        key={idx}
        selectedValue={value}
        name={name}
        onChange={onChange}
        {...option}
      />
    ))}
  </fieldset>
)

RadioArray.propTypes = {
  disabled: bool,
  name: string,
  onChange: func,
  options: array,
  value: any,
}

export default RadioArray
